export const marketingGlassCard =
  'rounded-[28px] border border-[#E8CFAE]/75 bg-[#FFF8ED]/86 text-[#1A1323] shadow-[0_22px_60px_-34px_rgba(120,73,31,0.26)] ring-1 ring-white/70 backdrop-blur-xl'

export const marketingCreamPanel =
  'overflow-hidden rounded-[32px] border border-[#E8CFAE]/70 bg-gradient-to-br from-[#FFF8EF]/94 via-[#F6EAD8]/56 to-[#FFF8ED]/92 text-[#1A1323] shadow-[0_26px_76px_-38px_rgba(120,73,31,0.3)] ring-1 ring-white/70 backdrop-blur-xl'

export const marketingDarkPanel =
  'relative overflow-hidden rounded-[34px] border border-[#FFF6E8]/12 bg-[radial-gradient(circle_at_22%_18%,rgba(246,180,67,0.2),transparent_30%),radial-gradient(circle_at_82%_70%,rgba(255,127,164,0.16),transparent_34%),linear-gradient(135deg,#07060A_0%,#18141e_52%,#2a152a_100%)] text-white shadow-[0_28px_90px_-44px_rgba(255,127,164,0.44)]'

export const marketingRoundedSurface =
  'overflow-hidden rounded-[32px] border border-[#E8CFAE]/65 bg-[#FFF8EF]/88 text-[#1A1323] shadow-[0_24px_70px_-40px_rgba(120,73,31,0.24)] ring-1 ring-white/60 backdrop-blur-xl'

export const marketingIconGradient =
  'bg-gradient-to-br from-[#FF8A65] via-[#FF7FA4] to-[#F6B443] text-white shadow-lg shadow-amber-500/25'

export const marketingDarkTextPrimary = 'text-[#F6EDE4]'
export const marketingDarkTextSecondary = 'text-[#D7C6B4]'
export const marketingLightTextPrimary = 'text-[#1A1323]'
export const marketingLightTextSecondary = 'text-[#6B5B53]'

/** Opaque public Dog Card on dark marketing backgrounds (Slice 2.12E). */
export const publicConnectDogCardPanel =
  'overflow-hidden rounded-[32px] border border-[#E8CFAE]/80 bg-[#FFF8EF] text-[#1A1323] shadow-[0_26px_76px_-38px_rgba(0,0,0,0.55)] ring-1 ring-[#FFF6E8]/40'

export const publicConnectDogCardLabel = 'text-[11px] font-semibold uppercase tracking-[0.12em] text-[#8A7468]'
export const publicConnectDogCardValue = 'text-[15px] font-medium text-[#1A1323]'
export const publicConnectDogCardEyebrow = 'text-sm font-medium text-[#6B5B53]'
export const publicConnectDogCardTitle = 'text-[28px] font-bold tracking-tight text-[#1A1323]'
export const publicConnectDogCardSubtitle = 'text-sm text-[#5C4D46]'
